module.exports = __webpack_public_path__ + "img/Frame 131.6289028a.png";